export default __webpack_public_path__ + "static/media/survey-form.cc12ca9f.svg";